import { render, staticRenderFns } from "./BrightStoreList.vue?vue&type=template&id=0f1b1540"
import script from "./BrightStoreList.vue?vue&type=script&lang=js"
export * from "./BrightStoreList.vue?vue&type=script&lang=js"
import style0 from "./BrightStoreList.vue?vue&type=style&index=0&id=0f1b1540&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports